import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = {
  class: "right_cont",
  style: {"width":"100%"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "pagination" }

import {getNewsContentList} from "@/config/request";
import { reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'news-list',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const newsList = ref([]) as any
const pagination = reactive({
      pageNo: 1,
      pageSize: 10,
      pageSizes: [5,10,20],
      total: 0,
})

const getNewsList = async() => {
    let param = {
        title:  route.query.title,
        pageNo: pagination.pageNo,
        pageSize: pagination.pageSize
    }
    console.log('param',param);

    const res = await getNewsContentList(param) as any
    newsList.value = res.result.records
    pagination.total = res.result?.total || 0
}

const showDetail = (item:any) => {
    router.push({
        path: '/news-detail',
        query:{
            id: item.id
        }
    })
}
const handleCurrentChange = (index:any) => {
    pagination.pageNo = index
    getNewsList()
}
const handleSizeChange = (index:any) => {
    pagination.pageSize = index
    getNewsList()
}
getNewsList()

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "t6_breadCream" }, [
            _createElementVNode("span", null, "首页"),
            _createTextVNode(),
            _createElementVNode("i", null, ">"),
            _createElementVNode("span", null, "政务公开"),
            _createTextVNode(),
            _createElementVNode("i", null, ">"),
            _createElementVNode("span", null, "查看更多")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_table, {
              data: newsList.value,
              size: "large"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  label: "序号",
                  width: "100",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "标题",
                  width: "600"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("a", {
                      type: "primary",
                      onClick: ($event: any) => (showDetail(scope.row))
                    }, _toDisplayString(scope.row.title), 9, _hoisted_5)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "releaseDate",
                  label: "发布时间",
                  width: "300",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "200",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: ($event: any) => (showDetail(scope.row))
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("查看", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_pagination, {
                background: "",
                onCurrentChange: handleCurrentChange,
                onSizeChange: handleSizeChange,
                layout: "total, prev, pager, next, jumper",
                "page-size": pagination.pageSize,
                "page-sizes": pagination.pageSizes,
                total: pagination.total
              }, null, 8, ["page-size", "page-sizes", "total"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})